<template>
  <div class="ownerManage">
    <div class="search_bar">
      <van-search
        class="search_input"
        v-model="listQuery.name"
        show-action
        placeholder="请输入货主姓名进行搜索"
        @search="onSearch"
      >
        <template slot="action">
          <div @click="onSearch">搜 索</div>
        </template>
      </van-search>
    </div>

    <div class="name_box">
      <van-index-bar
        :index-list="list_index"
        :sticky="false"
        highlight-color="#2c3e50"
        style="padding-bottom:1.5rem;"
      >
        <van-index-anchor v-for="(item,index) in list" :key="index" :index="index">
          <span>{{index}}</span>
          <van-cell
            class="item"
            v-for="(citem,cindex) in item"
            :key="cindex"
            :disabled="citem.status == 2"
            :label="'编号:'+citem.supplier_sn"
            :value="citem.status == 2?'已停用':citem.mobile"
            @click="use_type == 1?citem.status == 1?backPage(citem):'':toDetail(citem)"
          >
            <template #title>
              <div class="van-ellipsis" style="width:3.7rem;font-weight:bold;">{{citem.name}}</div>
            </template>
          </van-cell>
        </van-index-anchor>
      </van-index-bar>
    </div>

    <div class="add-btn" @click="$router.push('/manage/owner/addOwner')">添加货主</div>
  </div>
</template>

<script>
import { owner_list } from "@/api/work/manage/owner";
export default {
  name: "ownerManage",
  data() {
    return {
      list_index: [],
      list: [],
      loading: true,
      finished: true,
      refreshing: false,
      listQuery: {
        page: 1,
        pageSize: "150000",
        name: ""
      },

      use_type: 1
    };
  },
  created() {
    if (this.$route.query.use_type == 1) {
      this.use_type = 1;
    } else {
      this.use_type = 0;
    }
    this.getList();

    this.$navigation.on("back", (to, from) => {
      if (
        to.route.name == "manage_owner_ownerManage" ||
        from.route.name == "manage_owner_ownerDetail"
      ) {
        var listQuery = {
          page: 1,
          pageSize: this.list.length + 1,
          name: this.listQuery.name
        };
        owner_list(listQuery).then(res => {
          if (res.code == 200) {
            this.list = res.data.list;
            if (
              this.list.length == res.data.totalCount ||
              res.data.list.length == 0
            ) {
              this.finished = true;
            } else {
              this.finished = false;
              this.loading = false;
              this.listQuery.pageSize = "15";
            }
          }
        });
      }
    });
    if(this.$route.meta.backData){
      delete this.$route.meta.backData
    }
  },
  mounted() {},
  methods: {
    // 点击了搜索按钮
    onSearch() {
      this.listQuery.page = 1;
      this.getList();
    },

    // 获取列表
    getList() {
      owner_list(this.listQuery).then(res => {
        if (res.code == 200) {
          this.list = res.data.list ||[];
          this.list_index = [];
          for (const key in res.data.list) {
            this.list_index.push(key);
          }
          this.refreshing = false;
        }
      });
    },
    // 下拉刷新
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      this.refreshing = true;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.listQuery.page = 1;
      this.getList();
    },

    // 去详情
    toDetail(item) {
      this.$router.push({
        path: "/manage/owner/ownerDetail",
        query: {
          id: item.id
        }
      });
    },

    // 返回上一页
    backPage(item) {
      this.$route.meta.backData = item;
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="less" scoped>
.ownerManage {
  padding-bottom: 0.3rem;
  .name_box {
    position: fixed;
    padding-bottom: 1.28rem;
    box-sizing: border-box;
    width: 100%;
    height: calc(100% - 54px);
    margin-top: 54px;
    overflow-y: auto;
  }
  .search_bar {
    position: fixed;
    width: 100%;
    top: 0.88rem;
    z-index: 2;
    box-shadow: 0 0 0.05rem 0.05rem #f1f1f1;
  }
  .list {
    padding: 0.3rem;
    .item {
      margin-bottom: 0.2rem;
    }
  }
  .content {
    padding-bottom: 1.2rem;
    .lebel {
      font-size: 0.28rem;
      color: #666666;
      em {
        color: #ff0000;
      }
    }
  }
  .add-btn {
    width: 100%;
    line-height: 1rem;
    background-color: #31b158;
    color: #fff;
    font-size: 0.36rem;
    text-align: center;
    position: fixed;
    bottom: 0;
  }
}
</style>